const styles = {
  paper: {
    padding: "1em",
  },
  content: {
    padding: "3%",
  },
  button: {
    marginTop: "20px",
    textAlign: "center",
    marginLeft: "auto",
    marginRight: "3%",
  },
  textArea: {
    width: "205%",
  },
  firstRow: {
    display: "flex",
    flexDirection: "row",
  },
  textFieldContainer: {
    width: "50%",
    padding: "0 1%",
    marginBottom: "1em",
  },
  textField: {
    width: "100%",
  },
  rightTextField: {
    width: "100%",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  dropdown: {
    width: "30%",
  },
  buttonRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  rightButton: {
    marginTop: "20px",
    textAlign: "center",
    marginRight: "1%",
  },
  tableToolBar: {
    marginLeft: "2em",
    marginBottom: "1em",
  },
  title: {
    fontWeight: "bold",
  },
};

export default styles;
